import { getSubRouteParent, ROUTES } from '@ui/constants/routes';
import { getPathWithoutLocale } from '@ui/lib/i18n';
import { isSubRouteWithLocale } from '@ui/lib/i18n/isSubRouteWithLocale';

export const getActiveRoute = (routes: ROUTES[], currentRoute: string) => {
  const activeRoute = routes.find((route) => {
    // check if has parent route
    const parentRoute = getSubRouteParent(route);

    // check current route is under parent route
    return isSubRouteWithLocale(
      parentRoute ?? route,
      getPathWithoutLocale(currentRoute),
    );
  });

  return activeRoute;
};
